<template>
    <tr>
        <td>
            <div @click="openModal"> #{{ invoice.id }}</div>
            <proforma-invoice-modal :car="invoice.car" v-if="isActive"></proforma-invoice-modal>
        </td>
        <td>{{ invoice.issued_date }}</td>
        <td>{{ invoice.car.model_type_en }}</td>
        <td>{{ getCurrency }}{{ getDueAmount() | formatNumber }}</td>
        <td>
            <div class="field paid-amount-field">
                <div class="used_amount_tooltip">The amount entered here is more than the amount paid by the customer.</div>
                <p class="control used_amount-field is-fullwidth">
                    <input class="input" type="text" v-model="used_amount" v-on:change="depositPayment()">
                </p>
            </div>
        </td>
        <td v-if="action == 'add'">
            <div class="field select is-fullwidth select-deposit">
                <div class="control">
                    <select v-model="deposit" v-on:change="depositPayment()">
                        <option selected :value="null" disabled>Deposit</option>
                        <option value="100%">Pay in full</option>
                        <option value="50%-50%">50%</option>
                        <option value="30%-70%">30%</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

    import ProformaInvoiceColumn from "../Cars/Columns/ProformaInvoiceColumn";
    import ProformaInvoiceModal from "../Cars/Columns/ProformaInvoice/ProformaInvoiceModal";
    export default {
        props: ['invoice', 'transactionTotals', 'action'],
        components: {ProformaInvoiceModal, ProformaInvoiceColumn},
        data() {
            return {
                deposit : '',
                used_amount: this.action == 'add' ? '' : this.invoice.amount_used,
                deposit: this.action == 'add' ? '' : this.invoice.deposit,
            }
        },
        methods: {
            getDueAmount() {
                if (this.invoice.currency == 2 && this.transactionTotals.currency != 2) {
                    return Math.round((this.invoice.balance_due - this.invoice.paid_amount) * this.invoice.rate)
                } else if (this.invoice.currency == 1 && this.transactionTotals.currency != 1) {
                    return Math.round((this.invoice.balance_due - this.invoice.paid_amount) / this.invoice.rate)
                } else {
                    return this.invoice.balance_due - this.invoice.paid_amount
                }
            },
            depositPayment() {
                let deposit = this.deposit;
                //this.used_amount = this.invoice.amount_used;
                let balance = Number(this.invoice.balance_due);
                let paid_amount = Number(this.invoice.paid_amount);
                if (this.deposit == '100%') {
                    /*if (this.invoice.currency == 1 || this.invoice.currency == null) {
                        this.used_amount = balance - paid_amount
                    } else {
                        this.used_amount = Math.round((balance - paid_amount) * this.invoice.rate);
                    }*/
                    this.used_amount = balance - paid_amount
                } else if (this.deposit == '50%-50%') {
                    /*if (this.invoice.currency == 1 || this.invoice.currency == null) {
                        this.used_amount = (balance - paid_amount) * 50 / 100
                    } else {
                        this.used_amount = Math.round((balance - paid_amount) * (50 / 100) * this.invoice.rate);
                    }*/
                    this.used_amount = (balance - paid_amount) * 50 / 100
                } else if (this.deposit == '30%-70%') {
                    /*if (this.invoice.currency == 1 || this.invoice.currency == null) {
                        this.used_amount = (balance - paid_amount) * 30 / 100
                    } else {
                        this.used_amount = Math.round((balance - paid_amount) * (30 / 100) * this.invoice.rate);
                    }*/
                    this.used_amount = (balance - paid_amount) * 30 / 100
                } else if(this.deposit == 'custom'){
                    deposit = '';
                }
                this.invoice.amount_used = this.used_amount;

                this.$store.commit('setInvoiceAmountUsed', {'invoice_id': this.invoice.id, 'amount_used': this.used_amount, 'deposit': deposit})
                //this.$store.commit('setAmountUsed', this.used_amount)
                //this.$store.dispatch('paymentDepositInvoice', {transaction_id: this.$route.params.id, invoice_id: this.invoice.id, deposit: this.deposit, paid_amount: this.invoice.paid_amount})
            },
            openModal() {
                this.$store.dispatch('changeProformaInvoiceModalStatus', { status: true, carId: this.invoice.car.id })
                this.$store.dispatch('fetchProformaInvoice', this.invoice.car.id)
            }
        },
        computed: {
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            },
            isActive() {
                return this.$store.getters.getProformaInvoiceModalStatus(this.invoice.car.id)
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }

    .picture-td {
        width: 65px;
    }

    .link {
        cursor: pointer;
    }

    .image {
        cursor: pointer;
    }
    .used_amount-field {
        max-width: 110px;
    }
    .used_amount_tooltip{
        display: none;
    }
    .error-field .used_amount_tooltip {
        display: block;
        position: absolute;
        width: 169px;
        right: 100%;
        top: 0;
        background-color: #fcf9dc;
        border: 1px solid #ebcc6f;
        border-radius: 3px;
        color: #000;
        padding: 5px 10px;
    }

    .field.paid-amount-field {
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/EditUnpaidInvoiceTableRow.vue